import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import changestateaction from "../../context/action/expensetype/changestateaction";
import Editexpensetypemodal from "./editexpensetypemodal";
const Expensetypelist = () => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [expense_type_id, setexpense_type_id] = useState();
  const [expense_type_name, setexpense_type_name] = useState();
  const [mizania_statement_number, setmizania_statement_number] = useState();
  const [mizania_directory_number, setmizania_directory_number] = useState();
  const [show, setshow] = useState(false);
  return (
    <div>
      <Editexpensetypemodal
        show={show}
        setshow={setshow}
        expense_type_id={expense_type_id}
        expense_type_name={expense_type_name}
        setexpense_type_name={setexpense_type_name}
        mizania_statement_number={mizania_statement_number}
        setmizania_statement_number={setmizania_statement_number}
        mizania_directory_number={mizania_directory_number}
        setmizania_directory_number={setmizania_directory_number}
      />

      {/* Expense Type List Card */}
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی جۆری خەرجی</h2>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">ناو</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">رقم الكشف</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">رقم الدليل</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">دۆخ</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">گۆڕانکاری</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
            {initState.expense_type.map((lis) => (
              <tr key={lis.expense_type_id} className="hover:bg-slate-50 transition-colors duration-100">
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.expense_type_name}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.mizania_statement_number}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.mizania_directory_number}
                </td>
                <td className="px-6 py-4 text-right">
                  <button
                    className={
                      lis.expense_type_state == "active"
                        ? "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors cursor-pointer"
                        : "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-100 border border-red-200 transition-colors cursor-pointer"
                    }
                    onClick={() => {
                      changestateaction(
                        lis.expense_type_id,
                        lis.expense_type_state
                      )(recaller)(setrecaller)(initDispatch)(clear);
                    }}
                  >
                    {lis.expense_type_state}
                  </button>
                </td>
                <td className="px-6 py-4 text-right">
                  <button
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                    onClick={() => {
                      setexpense_type_id(lis.expense_type_id);
                      setexpense_type_name(lis.expense_type_name);
                      setmizania_statement_number(lis.mizania_statement_number);
                      setmizania_directory_number(lis.mizania_directory_number);
                      setshow(true);
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Expensetypelist;
